import { render, staticRenderFns } from "./SeasonStatusStaff.vue?vue&type=template&id=9620816a&"
import script from "./SeasonStatusStaff.vue?vue&type=script&lang=js&"
export * from "./SeasonStatusStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports